import { fromJS } from 'immutable';

import { loginRoutine, resetPasswordRoutine, fetchProfileRoutine } from '../routines';

const initialState = fromJS({
});

export default function (state = initialState, action) {
  switch (action.type) {
    case loginRoutine.SUCCESS:
    case fetchProfileRoutine.SUCCESS:
      return state.set('profile', fromJS(action.payload.response));
    case resetPasswordRoutine.TRIGGER:
      // return state.setIn('resetPassword')
      return state;
    case resetPasswordRoutine.SUCCESS:
      return state.set('message', 'Password reset email was sent. Please check your email.');
    case resetPasswordRoutine.FAILURE:
      return state.set('error', action.error);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/authentication.js